import { RegisterForm } from 'src/Components/Forms/RegisterForm';
import { ContentOverlay } from 'src/Containers/ContentOverlay';

const RegisterPage = () => {
  return (
    <ContentOverlay>
      <RegisterForm />
    </ContentOverlay>
  );
};

export default RegisterPage;
